import React from 'react';
import { CockpitButton } from 'components/views/atoms/CockpitButton';
import { faVolumeUp, faVolumeMute } from '@fortawesome/free-solid-svg-icons';

export type SpeakerButtonProps = {
    mute: boolean;
    disabled?: boolean;
    onClick: () => void;
}

export function SpeakerButton(props: SpeakerButtonProps) {
    const { mute, disabled, onClick } = props;

    return (
        <CockpitButton
            icon={mute ? faVolumeMute : faVolumeUp}
            disabled={disabled}
            onClick={onClick} />
    );
}
